// extracted by mini-css-extract-plugin
export default {"menuBlock":"qG-z","title":"rG-z","nav":"sG-z","flexCell":"tG-z","facetLink":"uG-z"};